import React from "react";
import { getTranslations } from "../../../../Helper/TranslationController";

const MachineCell = React.memo(({ value, overrideClass, translations }) => (
  <div className={`custom-formation-machine-cell ${overrideClass || ""}`}>
    <i className={`icon-${value.code}`} />
    <span className="custom-formation-machine-cell_label">
      {getTranslations(value.name, translations)}
    </span>
  </div>
));

export default MachineCell;
